module.exports = __webpack_public_path__ + "img/wordpress-logo.fa6246e6.png";